import { apiCallWrapper } from 'traveldesk-ui'

import TicketType from './../models/TicketType'

export default class TicketsApiService {
    static getTypes = async (dispatch: any) => {
        return await apiCallWrapper<TicketType[]>('/api/tickets/types', 'GET', dispatch)
    }
}
